import React, {Component} from "react";
import { Link } from 'react-router-dom';

import Constants from "../../../constants/constants";


import 'react-tippy/dist/tippy.css';

class PlayScreenCard extends Component {
    onClick() {
        const {card_data, token} = this.props;
        if (card_data.is_external) {
            let port = window.location.port;
            let platformURL = "https://" + window.location.hostname;

            if (port !== "") {
                platformURL += ":" + port;
            }
            platformURL = encodeURIComponent(platformURL);
            window.location = Constants.getPlayContentUrl() + card_data.view + "&auth=" + token + "&purl=" + platformURL;
            return;
        }
        else {
            if (card_data.view !== "") {
                this.props.history.push(card_data.view);
            }    
        }
    }

    render() {
        const {card_data, locked} = this.props;
        let cardClass = card_data.card_class;

        let comingSoon = false;
        if (card_data.coming_soon) {
            comingSoon = true;
        }
        
        //const bottomTitle = card_data.bottom_title;
        const ribbon = card_data.ribbon ? card_data.ribbon : false;
        cardClass += " new_play_screen_button";


        
        let cardStyle = {
            "color": "white"
        };

        if (comingSoon) {
            cardClass += " coming_soon";
        }

        if (locked) {
            cardClass += " locked";
        }

        //const isExternal = card_data.isExternal;
        if (locked) {
            return (
                <div className={cardClass} style={cardStyle}>
                    <div className='new_play_screen_button_text'>{card_data.title}</div>
                    <i className='new_play_screen_button_play_icon fa fa-play-circle'></i>
                </div>
            )
            
        }
        else if (card_data.is_external) {
            return(
                <div onClick={this.onClick.bind(this)} className={cardClass} style={cardStyle}>   
                    {ribbon && <div className='play_card_ribbon'>{ribbon}</div>}             
                    <div className='new_play_screen_button_text'>{card_data.title}</div>
                    <i className='new_play_screen_button_play_icon fa fa-play-circle'></i>                
                </div>
            )
            
        }
        else {
            return (
            <Link to={card_data.view} className={cardClass} style={cardStyle}>    
                    {ribbon && <div className='play_card_ribbon'>{ribbon}</div>}            
                    <div className='new_play_screen_button_text'>{card_data.title}</div>
                    <i className='new_play_screen_button_play_icon fa fa-play-circle'></i>                
            </Link>
            )
        }
        
    }
}

export default PlayScreenCard;


// WEBPACK FOOTER //
// ./src/components/containers/play-screen/new-play-screen-card.js